var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userData)?_c('div',{staticClass:"home-welcome"},[_c('h1',{staticClass:"mb-0"},[_vm._v(" Bienvenido, "+_vm._s(_vm.userData.fullName)+" ")]),_c('p',{staticClass:"text-muted mb-0"},[_vm._v(" Portal de clientes de Telemon ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }